import { DEFAULT_INPUT } from './defaults';
import { DEFAULT_FEATURES, type FormValues } from './form';

export { SETTINGS, type RateKey, type ScenarioKey } from './settings';
export {
	ACTIVITY_TYPES,
	PROFILE_MULTIPLIERS,
	type ActivityType,
	type ProfileKey,
} from './profiles';
export { DEFAULT_INPUT, STEP_NAMES, type CalculatorInput, type YesNo } from './defaults';
export {
	DEFAULT_FEATURES,
	CONTACT_FIELDS,
	contactRule,
	type FeatureFlags,
	type FormValues,
} from './form';

export const DEFAULT_FORM_VALUES: FormValues = {
	...DEFAULT_INPUT,
	...DEFAULT_FEATURES,
};
